import { SelectOption } from '@cks-internal/react-base';

// Enums
export enum ApprovalRuleOverrideType {
  None = 0,
  Cities = 1,
  CityTags = 2,
  Contacts = 3,
  ContactTags = 4
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

// Base models
export interface ApproverAvailabilityModel {
  Id?: number | null;
  DaysOfWeek: number[]; // DayOfWeek enum values
  StartTime: string;
  EndTime: string;
}

export interface ApproverTravellerAssignmentModel {
  Id?: number | null;
  TravellerId: number;
  TravellerName?: string | null;
  Order?: number | null;
}

export interface CompanyApproverModel {
  Id?: number | null;
  ApproverContactId: number;
  Availability?: ApproverAvailabilityModel[];
  AssignedTravellers?: ApproverTravellerAssignmentModel[];
  EnableEmailApprovals?: boolean;
  EnableSMSApprovals?: boolean;
  IsFallback?: boolean;
  Order?: number | null;
  BranchOfficeIds?: number[];
}

// Rule configuration models
export interface RuleOverrideBaseModel {
  OverrideType: ApprovalRuleOverrideType;
  CityIds?: number[];
  CityTags?: string[];
  ContactIds?: number[];
  ContactTags?: string[];
  InitialCities?: SelectOption[];
  InitialContacts?: SelectOption[];
}

export interface SelfBookingRequiresApprovalOverrideModel extends RuleOverrideBaseModel {}

export interface RateCapRuleOverrideModel extends RuleOverrideBaseModel {
  MaxAmount?: number;
  MaxAmountDoubleOccupancy?: number | null;
  HardCap?: number | null;
  HardCapDoubleOccupancy?: number | null;
}

export interface SelfBookingRequiresApprovalConfigurationModel {
  IsEnabledForAgentBookings?: boolean;
  IsEnabledForObtBookings?: boolean;
  Overrides?: SelfBookingRequiresApprovalOverrideModel[];
}

export interface AutoApproveBetweenHoursTimeRangeModel {
  DaysOfWeek: number[];
  StartTime: string;
  EndTime: string;
}

export interface AutoApproveBetweenHoursConfigurationModel {
  IsEnabledForAgentBookings?: boolean;
  IsEnabledForObtBookings?: boolean;
  TimeRanges?: AutoApproveBetweenHoursTimeRangeModel[];
}

export interface RateCapRuleConfigurationModel {
  IsEnabledForAgentBookings?: boolean;
  IsEnabledForObtBookings?: boolean;
  MaxAmount?: number;
  MaxAmountDoubleOccupancy?: number | null;
  HardCap?: number | null;
  HardCapDoubleOccupancy?: number | null;
  Overrides?: RateCapRuleOverrideModel[];
}

// Main configuration model
export interface CompanyApprovalConfigurationModel {
  Id?: number | null;
  CompanyId: number;
  TimeZoneAddressString: string;
  TimeZoneLat: number;
  TimeZoneLng: number;
  ApprovalBackupTimeMinutes: number;
  CompanyWideApprovers?: CompanyApproverModel[];
  ContactOnlyApprovers?: CompanyApproverModel[];
  BranchOfficeApprovers?: CompanyApproverModel[];
  SelfBookingRequiresApprovalConfigurationModel: SelfBookingRequiresApprovalConfigurationModel;
  AutoApproveBetweenHoursConfigurationModel: AutoApproveBetweenHoursConfigurationModel;
  RateCapRuleConfigurationModel: RateCapRuleConfigurationModel;
  IsEnabledForAgentBookings?: boolean;
  IsEnabledForObtBookings?: boolean;
  Notes?: string;
}
